/**
 * Modal Container Component
 *
 * Renders active modals with backdrop.
 */

import { modals, closeModal } from '@/stores/ui';
import { useEffect } from 'preact/hooks';

// Modal components registry (currently unused, will add dynamic modals later)
// const modalComponents: Record<string, () => preact.JSX.Element> = {};

export function ModalContainer() {
  // Handle escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && modals.value.length > 0) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

  if (modals.value.length === 0) return null;

  return (
    <div class="modal-container">
      {modals.value.map((modal, index) => (
        <div key={modal.id} class="modal-wrapper">
          {/* Backdrop (only for top modal) */}
          {index === modals.value.length - 1 && (
            <div
              class="modal-backdrop"
              onClick={() => closeModal(modal.id)}
            />
          )}

          {/* Modal content */}
          <div
            class="modal"
            role="dialog"
            aria-modal="true"
          >
            <button
              class="modal-close"
              onClick={() => closeModal(modal.id)}
              aria-label="Close modal"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>

            {/* Render modal component */}
            <ModalContent modal={modal} />
          </div>
        </div>
      ))}
    </div>
  );
}

function ModalContent({ modal }: { modal: { component: string; props?: Record<string, unknown> } }) {
  // For now, render a placeholder - components will be added
  return (
    <div class="modal-content">
      <p>Modal: {modal.component}</p>
      {modal.props && (
        <pre>{JSON.stringify(modal.props, null, 2)}</pre>
      )}
    </div>
  );
}
